import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "side-bar-item"
};
import MenuItem from './menuItem.vue';
import SubMenu from './subMenu.vue';
const __default__ = {
  name: 'SideBarItem'
};
function setup(__props) {
  return (_ctx, _cache) => {
    const _component_side_bar_item = _resolveComponent("side-bar-item", true);
    return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.currentRoute.children && __props.currentRoute.meta?.show && __props.currentRoute.meta?.isSubMenu ? (_openBlock(), _createBlock(SubMenu, {
      key: __props.path,
      "current-route": __props.currentRoute
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currentRoute.children, childItem => {
        return _openBlock(), _createBlock(_component_side_bar_item, {
          key: childItem.path,
          "current-route": childItem,
          path: childItem.path,
          layer: __props.layer + 1
        }, null, 8, ["current-route", "path", "layer"]);
      }), 128))]),
      _: 1
    }, 8, ["current-route"])) : (_openBlock(), _createBlock(MenuItem, {
      key: __props.currentRoute.path,
      "current-route": __props.currentRoute,
      layer: __props.layer
    }, null, 8, ["current-route", "layer"]))]);
  };
}
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    currentRoute: {
      type: null,
      required: true,
      default: {}
    },
    path: {
      type: String,
      required: true,
      default: ''
    },
    layer: {
      type: Number,
      required: true,
      default: 0
    }
  },
  setup
});